import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleRecommend() {
  const featuredArticles = articles.filter((a) => a.isFeatured).slice(0, 3);

  return (
    <section className="w-full py-14 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-label text-secondary-500 tracking-[0.2em] uppercase mb-2">
            Expert Insights
          </p>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
            精选文章
          </h2>
          <p className="mt-2 text-sm text-foreground-600 max-w-md mx-auto">
            专业知识与生活灵感，助你更好地享受品质生活
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-[10px] font-label px-2 py-0.5 rounded-full bg-accent-100 text-accent-700">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="text-sm md:text-base font-label font-medium text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.summary}
                </p>
                <div className="mt-3 pt-3 border-t border-background-200/50 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{article.author}</span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/articles"
            className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-label font-medium whitespace-nowrap rounded-full border border-secondary-300 text-foreground-700 hover:bg-secondary-50 transition-colors cursor-pointer"
          >
            阅读更多文章
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}